import { useState } from 'react';

const PilotRequest = ({title, onClose}) => {
    const [formData, setFormData] = useState({
        name: '',
        organisation: '',
        telephone: '',
        email: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const getEmailBody = () => {
        const baseText = title === 'пилот' 
            ? `Уважаемые коллеги,

Прошу рассмотреть возможность участия нашей организации в пилотном проекте по ...

Наша организация заинтересована в ...

С уважением,`
            : `Уважаемые коллеги,

Прошу организовать демонстрацию системы мониторинга ...

Мы заинтересованы в ознакомлении с функциональными возможностями системы и оценке её применимости для наших задач.

С уважением,`;

        return `${baseText}
${formData.name}
${formData.organisation}

Контактные данные:
Телефон: ${formData.telephone}
Email: ${formData.email}`;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const subject = `Заявка на ${title}`;
        const body = getEmailBody();
        const mailtoLink = `mailto:info@ruscomtech.ru?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoLink;
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-start justify-center z-[100]">
            <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 relative mt-[8%]">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-100 hover:text-gray-700 bg-black rounded-[50%] p-1"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={4}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>

                <h2 className="text-[20px] font-bold my-6 text-center">
                    {title === 'пилот' ? 'Заявка на пилот' : 'Запрос на демонстрацию'}
                </h2>

                <form onSubmit={handleSubmit} className='flex flex-col justify-center items-center'>
                    <div className="mb-6 w-full max-w-[420px]">
                        <label htmlFor="name" className="hidden text-gray-700 text-sm font-bold mb-2">
                            Имя
                        </label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder='Имя'
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-[50px]"
                        />
                    </div>

                    <div className="mb-6 w-full max-w-[420px]">
                        <label htmlFor="organisation" className="hidden text-gray-700 text-sm font-bold mb-2">
                            Вашa организации
                        </label>
                        <input
                            type="text"
                            id="organisation"
                            name="organisation"
                            value={formData.organisation}
                            onChange={handleChange}
                            required
                            placeholder='Вашa организации'
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-[50px]"
                        />
                    </div>

                    <div className="mb-6 w-full max-w-[420px]">
                        <label htmlFor="telephone" className="hidden text-gray-700 text-sm font-bold mb-2">
                            Телефон
                        </label>
                        <input
                            type="tel"
                            id="telephone"
                            name="telephone"
                            value={formData.telephone}
                            onChange={handleChange}
                            required
                            placeholder='Телефон'
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-[50px]"
                        />
                    </div>

                    <div className="mb-6 w-full max-w-[420px]">
                        <label htmlFor="email" className="hidden text-gray-700 text-sm font-bold mb-2">
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder='Email'
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-[50px]"
                        />
                    </div>

                    <button
                        type="submit"
                        className={`w-full max-w-[420px] mb-12 py-2 px-4 rounded text-white font-bold bg-[#BF9672] h-[50px]`}
                    >
                        Отправить заявку
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PilotRequest;